import { Component } from '@angular/core'

@Component({
  selector: 'app-product-purchase-order-fork',
  templateUrl: './product-purchase-order-fork.component.html',
  styleUrls: ['./product-purchase-order-fork.component.scss'],
})
export class ProductPurchaseOrderForkComponent {}
